"use strict";

require("../../style/index.less");

require("./index.less");

require("../../select/style");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/pagination/style/index.js
// module id = 247
// module chunks = 1